<template>
  <el-submenu v-if="item.children && item.children.length > 0" style="min-height: 60px;line-height: 60px"
    :index="item.path">
    <template slot="title">
      <img v-if="item.meta" :src="require(`@/assets/sidebar/${item.meta.icon}`)" alt="" class="menu-icon">
      <span v-if="item.meta">{{ item.meta.title }}</span>
    </template>
    <template v-for="child in item.children">
      <subItem :key="child.path" :item="child"></subItem>
    </template>
  </el-submenu>
  <el-menu-item v-else style="height: 60px;line-height: 60px" :index="item.path"
    :class="{ active: activePath == item.path }">
    <img v-if="item.meta" :src="require(`@/assets/sidebar/${item.meta.icon}`)" alt="" class="menu-icon">
    <span slot="title" v-if="item.meta">{{ item.meta.title }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: "subItem",
  props: ['item'],
  computed: {
    activePath() {
      return this.$route.meta.activeMenu || this.$route.fullPath
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.menu-icon {
  width: 31px;
  height: 34px;
  margin-right: 8px;
}

.el-submenu__title+.el-menu {
  .el-menu-item {
    padding: 0 30px !important;
  }

  .menu-icon {
    width: 36px;
    height: 36px;
    margin-right: 4px;
  }
}


.active {
  background: #f2f9f7 !important;
  color: #00a786 !important;
  position: relative;

  &::after {
    content: '';
    width: 5px;
    height: 40px;
    background: #0fbf9c;
    border-radius: 0 20px 20px 0;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>